import { BeneficiaryCountry } from '@seapoint/server/enums';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { getBeneficiaryCountryDetails } from '../../utils/get-beneficiary-country-details';

type CountryNameCardProps = {
  countryCode: BeneficiaryCountry;
};

export const CountryNameCard = ({ countryCode }: CountryNameCardProps) => {
  const { name, flag: Flag } = getBeneficiaryCountryDetails(countryCode);

  return (
    <Stack
      space={1}
      align="stretch"
      aria-labelledby="country-name-card-label"
      aria-describedby="country-description"
      className="w-full rounded-lg border border-border bg-muted p-4"
    >
      <p id="country-name-card-label" className="text-xs font-medium text-muted-foreground">
        Country
      </p>

      <Inline>
        <div className="h-5 w-5 overflow-clip rounded-full">
          <Flag className="h-full w-full" />
        </div>

        <p id="country-description" className="text-sm font-medium text-black">
          {name}
        </p>
      </Inline>
    </Stack>
  );
};
